function extractFileName(fileName: string): string {
  const parts: string[] = fileName.split('.');
  parts.pop();

  return parts.join('.');
}

export default extractFileName;
